document.querySelectorAll('[data-reviews-track]').forEach((track) => {
  const controls = track.parentElement.querySelector('[data-reviews-controls]');
  const previous = controls?.querySelector('[data-reviews-previous]');
  const next = controls?.querySelector('[data-reviews-next]');
  if (!controls || !previous || !next) return;

  controls.hidden = false;
  const isRtl = getComputedStyle(track).direction === 'rtl';
  const updateButtons = () => {
    const distance = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth;
    previous.disabled = distance < 2;
    next.disabled = distance >= max - 2;
  };
  const move = (forward) => {
    const card = track.querySelector('.reviews-clean__card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card.getBoundingClientRect().width + gap;
    const sign = (forward ? 1 : -1) * (isRtl ? -1 : 1);
    track.scrollBy({ left: sign * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };

  previous.addEventListener('click', () => move(false));
  next.addEventListener('click', () => move(true));
  track.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
});
